export function setStore(name, value) {
    if (!name) return;
    if (typeof value !== 'string') {
        value = JSON.stringify(value);
    }
    window.localStorage.setItem(name, value);
}

export function getStore(name) {
    if (!name) return;
    let value = window.localStorage.getItem(name);
    return value ? JSON.parse(value) : null;
}

export function removeStore(name) {
    if (!name) return;
    window.localStorage.removeItem(name);
}
